import styled from 'styled-components'

export const EntityNameTextStyled = styled.span`
  font-weight: ${(props) => props.theme.fontWeights.semibold};
`
